import React from "react";
import TableCell from "~/components/old-table-cell";
import Button from "~/components/button";
import { cloneExpenseRateSheet, cloneTaskRateSheet } from "~/routes";
import ClickSwallower from "~/click-swallower";
import moment from "moment";
import {
  createSearchRegex,
  TextHighlighter,
} from "~/components/text-highlighter";
import { RateSheet, RateSheetType } from "./types";
import { ArchiveRateSheet } from "./Archive";

type RateSheetItemProps = {
  rateSheet: RateSheet;
  canEdit: boolean;
  type: RateSheetType;
  search: string;
};

export const RateSheetItem: React.FC<RateSheetItemProps> = ({
  rateSheet,
  canEdit,
  type,
  search,
}) => {
  const { name, allowAssignment, archived, endDate, lastUsed } = rateSheet;

  const cloneRoute =
    type === "Expense" ? cloneExpenseRateSheet : cloneTaskRateSheet;

  const searchRegex = createSearchRegex(search);

  return (
    <>
      <TableCell>
        <TextHighlighter text={name} search={searchRegex} />
      </TableCell>
      <TableCell text={allowAssignment ? "Yes" : "No"} />
      <TableCell text={archived ? "Yes" : "No"} />
      <TableCell text={endDate ? moment(endDate).format("MM/DD/yyyy") : ""} />
      <TableCell text={lastUsed ? moment(lastUsed).format("MM/DD/yyyy") : ""} />
      <TableCell>
        {canEdit && (
          <ClickSwallower>
            <ArchiveRateSheet {...{ sheet: rateSheet }} />
            <Button outlined route={cloneRoute.toRoute(name)}>
              Copy
            </Button>
          </ClickSwallower>
        )}
      </TableCell>
    </>
  );
};
